/* SBO v3 ingredients: opens one ingredient's explanation at a time.
   Loaded by sections/sbo-v3-ingredients.liquid.

   Wide screens show the index beside a single panel, so one ingredient is
   always open and choosing another swaps the panel. Narrow screens show an
   accordion, where the open ingredient can also be closed. The markup is the
   same in both; only this rule and the section's CSS differ. */

(() => {
  const wide = window.matchMedia('(min-width: 1200px)');

  function setOpen(tab, open) {
    const panel = document.getElementById(tab.getAttribute('aria-controls'));
    tab.setAttribute('aria-expanded', String(open));
    if (panel) panel.toggleAttribute('data-sbo3-closed', !open);
  }

  function init(root) {
    root.querySelectorAll('[data-sbo3-ingredients]').forEach(section => {
      if (section.dataset.sbo3Ready) return;
      section.dataset.sbo3Ready = 'true';
      const tabs = Array.from(section.querySelectorAll('[data-sbo3-ingredient-tab]'));

      function ensureOneOpen() {
        if (wide.matches && !tabs.some(tab => tab.getAttribute('aria-expanded') === 'true') && tabs[0]) {
          setOpen(tabs[0], true);
        }
      }

      /* Closed panels are display: none, so their lazy photos wait. Start the
         download as soon as a name is pointed at or focused, so the photo is
         usually there by the time the panel opens. */
      const warm = tab => {
        const panel = document.getElementById(tab.getAttribute('aria-controls'));
        const photo = panel && panel.querySelector('img[loading="lazy"]');
        if (photo) photo.loading = 'eager';
      };

      tabs.forEach(tab => {
        tab.addEventListener('pointerenter', () => warm(tab), { once: true });
        tab.addEventListener('focus', () => warm(tab), { once: true });
        tab.addEventListener('click', () => {
          const isOpen = tab.getAttribute('aria-expanded') === 'true';
          if (isOpen && wide.matches) return;
          tabs.forEach(other => { if (other !== tab) setOpen(other, false); });
          setOpen(tab, !isOpen);
          /* On a phone the panel opens under the name; keep the name in view
             when the one above it closes and the page shifts up. */
          if (!isOpen && !wide.matches && tab.getBoundingClientRect().top < 0) {
            const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            tab.scrollIntoView({ block: 'start', behavior: still ? 'auto' : 'smooth' });
          }
        });
      });

      wide.addEventListener('change', ensureOneOpen);
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:block:select', event => {
    const tab = event.target.closest && event.target.closest('[data-sbo3-ingredient-tab]');
    if (tab && tab.getAttribute('aria-expanded') !== 'true') tab.click();
  });
})();
